import api from '@/lib/api';

/**
 * Fetch composed video prompt (ordered dialogue + scene direction) before the video API call.
 */
export async function fetchVideoGenerationPrompt({
  sceneId,
  projectId,
  segmentId,
  segmentNumber,
  provider,
  cameraMotion,
}) {
  const params = {};
  if (provider) {
    params.provider = provider;
    params.video_provider = provider;
  }
  if (cameraMotion && cameraMotion !== 'auto') {
    params.camera_motion = cameraMotion;
  }

  if (projectId && segmentId) {
    const { data } = await api.get(
      `/narration/projects/${projectId}/segments/${segmentId}/video-generation-prompt`,
      { params: { ...params, ...(segmentNumber ? { segment_number: segmentNumber } : {}) } },
    );
    return data;
  }

  const { data } = await api.get(`/scenes/${sceneId}/video-generation-prompt`, { params });
  return data;
}
